var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5C8.01562 0.5 0 8.58594 0 18.5C0 28.4844 8.01562 36.5 18 36.5C27.9141 36.5 36 28.4844 36 18.5C36 8.58594 27.9141 0.5 18 0.5ZM17.9297 24.125C19.4062 24.125 20.8125 23.5625 21.7969 22.5078C22.5 21.875 23.5547 21.875 24.1875 22.5078C24.8906 23.1406 24.8906 24.1953 24.2578 24.8984C22.5703 26.5859 20.3203 27.5 17.9297 27.5C12.375 27.5 9 22.8594 9 18.5C9 14.2109 12.3047 9.5 17.9297 9.5C20.3203 9.5 22.5703 10.4844 24.2578 12.1719C24.8906 12.8047 24.8906 13.9297 24.1875 14.5625C23.5547 15.1953 22.5 15.1953 21.7969 14.5625C20.8125 13.5078 19.4062 12.875 17.9297 12.875C14.4141 12.875 12.375 15.8281 12.375 18.5C12.375 21.1719 14.4141 24.125 17.9297 24.125Z",
    fill: "#4BB218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIcon);
export default __webpack_public_path__ + "static/media/CIcon.46759a833e57cf504b6eb6133b182d6a.svg";
export { ForwardRef as ReactComponent };